import API from './API.js';
export default class News extends API {
    constructor() {
        super('news');
    }

}
